import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"

const vipTiers = [
  {
    id: 1,
    tier: "Emerald",
    icon: "/images/icon/vip/emerald-icon-unique.webp",
  },
  {
    id: 2,
    tier: "Sapphire",
    icon: "/images/icon/vip/sapphire-icon-unique.webp",
  },
  {
    id: 3,
    tier: "Ruby",
    icon: "/images/icon/vip/ruby-icon-unique.webp",
  },
  {
    id: 4,
    tier: "Diamond",
    icon: "/images/icon/vip/diamond-icon-unique.webp",
  },
  {
    id: 5,
    tier: "Alexandrite",
    icon: "/images/icon/vip/alexandrite-icon-unique.webp",
  },
]

const benefits = [
  {
    label: "Required Deposit",
    values: {
      1: "0",
      2: "5,000",
      3: "20,000",
      4: "100,000",
      5: "500,000",
    },
  },
  {
    label: "Required Turnover",
    values: {
      1: "0",
      2: "150,000",
      3: "500,000",
      4: "1,500,000",
      5: "4,500,000",
    },
  },
  {
    label: "Daily Bonus",
    values: {
      1: "-",
      2: "5",
      3: "10",
      4: "20",
      5: "35",
    },
  },
  {
    label: "Weekly Cashback",
    values: {
      1: "3%",
      2: "4%",
      3: "5%",
      4: "6%",
      5: "7%",
    },
  },
  {
    label: "Referral Bonus",
    values: {
      1: "15%",
      2: "16%",
      3: "17%",
      4: "18%",
      5: "19%",
    },
  },
  {
    label: "Payday Bonus",
    values: {
      1: "50",
      2: "up to 150",
      3: "up to 450",
      4: "up to 1050",
      5: "up to 1800",
    },
  },
  {
    label: "Birthday Bonus",
    values: {
      1: "250",
      2: "500",
      3: "750",
      4: "1000",
      5: "2000",
    },
  },
  {
    label: "Rolling Commission",
    values: {
      1: "-",
      2: "-",
      3: "0.05%",
      4: "0.10%",
      5: "0.15%",
    },
  },
]
export default function VipLevels() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>VIP Levels - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Join FGH VIP Club for exclusive bonuses, referral rewards & elite perks. Fast payouts, local wallet support (GCash/Maya), Filipino casino loyalty for players 21+."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="main-body-content all-page-main-container-min-height main-container-global-adjusted-padding">
        <div className="vip-page-main">
          <img
            src="/images/promotions/main-banners/vip-rolling-commission-banner-XL.webp"
            className="vip-page-banner"
          />
          <div className="vip-page-container">
            <div className="vip-page-content">
              {/* Main wrapper for the responsive layout */}
              <div className="vip-levels-wrapper">
                <div className="benefits-sidebar">
                  <div className="vip-tiers-label">VIP Hub</div>
                  {benefits.map((benefit, idx) => (
                    <div key={idx} className="benefit-label vip-items-padding">
                      {benefit.label}
                    </div>
                  ))}
                </div>
                <div className="vip-tiers-container">
                  {vipTiers.map((tier) => (
                    <div key={tier.id} className="vip-tier-item">
                      {/* VIP tier header: icon and tier name */}

                      <div className="vip-tier-header">
                        <img src={tier.icon} alt={tier.tier} />
                      </div>
                      {/* VIP tier benefit values aligned with sidebar labels */}
                      <div className="vip-tier-values">
                        {benefits.map((benefit, idx) => {
                          // Create dynamic class from benefit label
                          const dynamicClass = `benefit-value ${benefit.label
                            .toLowerCase()
                            .replace(/\s+/g, "-")}`
                          return (
                            <div
                              key={idx}
                              // Combine the original classes with the new dynamic class
                              className={`benefit-value vip-items-padding`}
                            >
                              <span>{benefit.label}:</span>
                              <div className="benefit-value-details">
                                {benefit.values[tier.id]}
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* End of vip-levels-wrapper */}
            </div>
            <div className="fgh-section-margin fgh-section-articles">
              <div className="fgh-main-page-content">
                <h2 className="fgh-h2-style standard-margin-bottom">
                  Join the enhanced FGH VIP Level for exclusive perks, Ka-FGH!
                </h2>
                <h4>Take your gameplay to the next level!</h4>
                <ol>
                  <li>
                    <strong> VIP Level Upgrade </strong> - If a player's current
                    VIP Level is Emerald and they qualify for the Diamond VIP
                    Level within a few days, the player will be automatically
                    upgraded to Diamond the next day at 14:00NN after completing
                    the required deposit and turnover. <br></br>
                  </li>
                  <li>
                    <strong> Daily Rewards </strong>- Players who successfully
                    log in to their FGH account and make at least one successful
                    deposit from 12NN to 11:59Am next day will have a daily
                    login bonus at 1Pm according to their VIP Level.<br></br>
                  </li>
                  <li>
                    <strong> Rollover Requirement </strong>- Unless stated
                    otherwise, all bonuses are subject to a 3x rollover
                    requirement before any withdrawals. <br></br>
                  </li>
                  <li>
                    <strong> VIP Level Validity </strong>- Once achieved, a
                    player's VIP Level will remain the same for three months to
                    ensure consistent
                    <br></br>
                  </li>
                  <li>
                    <strong>VIP Level Downgrade</strong> - After the three-month
                    grace period, if a player becomes inactive or has reduced
                    participation, their VIP Level will be downgraded by one
                    level.
                  </li>
                  <li>
                    <strong>Unused Bonus Reset Policy</strong> - Once credited,
                    bonuses must be used before 11:00Am on the first day of the
                    following month. Any unused bonus balanced after this period
                    will automatically reset and be forfeited.
                  </li>
                  <li>
                    <strong>General Terms</strong> - FGH reserves the right to
                    modify, suspend or cancel the VIP Level Promo at any time to
                    ensure the best experience for our valued players.
                  </li>
                  <li>
                    <strong> Turnover & Deposit Request </strong> - Whenever a
                    player is upgraded to a new VIP level, their turnover and
                    deposit counters will be reset to zero.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
